import React from 'react';
import { NButton, NIcon, NSpinner } from '@innersource-nn/novoui-react';
import useDomain from '../hooks/useDomain';

type Props = {
    environmentUri: string;
    loading: boolean;
    newDomain: boolean;
};

export default function LoadingFailedStateDomain({
    environmentUri,
    newDomain,
    loading,
}: Props) {
    const { deleteDomain, deleteLoading } = useDomain(environmentUri);

    return (
        <div className="px-44 py-32">
            <div className="py-32 flex flex-col justify-center items-center">
                {loading ? (
                    <NSpinner color="blue" size="medium" />
                ) : (
                    <div className="bg-lava-red-200 round-div-icon-middle h-[5rem]	w-[5rem] ">
                        <NIcon
                            iconName="alert"
                            size={40}
                            className="fill-true-blue"
                        />
                    </div>
                )}
                <div className="w-2/3 text-base text-true-blue flex flex-col items-center">
                    <h1 className="text-lg my-8 font-bold">
                        {loading
                            ? ` Domain ${newDomain ? 'creation' : 'update'} in
                        progress...`
                            : 'Domain creation failed'}
                    </h1>
                    <p className="text-center">
                        {loading
                            ? `We are now ${newDomain ? 'creating' : 'updating'} your
                        new domain, please check back in a bit. The creation can
                        take up to 5 - 10 minutes`
                            : 'We encountered an error while attempting to create your domain. Please check the configuration file and try again. '}
                    </p>
                </div>
                {!loading && (
                    <NButton
                        variant="destructive"
                        className="mt-16"
                        square
                        size="sm"
                        onClick={deleteDomain}
                        isLoading={deleteLoading}
                    >
                        Delete domain configuration
                    </NButton>
                )}
            </div>
        </div>
    );
}
